import { SubmenuNavRef } from '@components/Nav/SubmenuNav';

import MobileArticleShare from './MobileSteps/ArticleShare';
import MobileDeepResearchAndSearch from './MobileSteps/DeepResearchAndSearch';
import MobileDownloadApp from './MobileSteps/DownloadApp';
import MobileNewsletters from './MobileSteps/Newsletters';
import MobileProFeatures from './MobileSteps/ProFeatures';
import MobileSettings from './MobileSteps/Settings';
import MobileTitv from './MobileSteps/Titv';
import MobileWelcome from './MobileSteps/Welcome';
import ArticleShare from './Steps/ArticleShare';
import DeepResearchAndSearch from './Steps/DeepResearchAndSearch';
import DownloadApp from './Steps/DownloadApp';
import Newsletters from './Steps/Newsletters';
import ProFeatures from './Steps/ProFeatures';
import Settings from './Steps/Settings';
import Titv from './Steps/Titv';
import Welcome from './Steps/Welcome';

export const ONBOARDING_STEP_IDS = {
  Welcome: 'Welcome',
  ProFeatures: 'ProFeatures',
  DeepResearchAndSearch: 'DeepResearchAndSearch',
  Newsletters: 'Newsletters',
  Titv: 'Titv',
  Settings: 'Settings',
  ArticleShare: 'ArticleShare',
  DownloadApp: 'DownloadApp',
} as const;

export const ELEMENT_Z_INDEX = 1250;
export const NAV_BREAKPOINT_PX = 1120;
export const OVERLAY_Z_INDEX = 1200;
export const POPPER_Z_INDEX = 1300;
export const NEWSLETTER_ANCHOR_SELECTOR = '[data-onboarding-anchor="newsletters"]';
export const NEWSLETTER_HOVER_CLASS = '!text-primary-magenta';

// Events
export const ONBOARDING_STEP_CHANGE_EVENT = 'user-onboarding-step-change';
export const ONBOARDING_PRO_NAV_REGISTER_EVENT = 'user-onboarding-pro-nav-register';
export const ONBOARDING_MORE_NAV_REGISTER_EVENT = 'user-onboarding-more-nav-register';
export const ONBOARDING_SETTINGS_NAV_REGISTER_EVENT = 'user-onboarding-settings-nav-register';
export const ONBOARDING_ANCHOR_REGISTER_EVENT = 'user-onboarding-anchor-register';

// Registry
const proNavRef: { current: SubmenuNavRef | null } = { current: null };
const moreNavRef: { current: SubmenuNavRef | null } = { current: null };
const settingsNavRef: { current: SubmenuNavRef | null } = { current: null };
const anchors: Record<string, HTMLElement | null> = {};

export const onboardingRegistry = {
  proNavRef,
  moreNavRef,
  settingsNavRef,
  anchors,
};

// Steps
type StepComponent = (props) => React.JSX.Element;

export type StepTuple = readonly StepComponent[];

export const PRO_STEPS: StepTuple = [
  Welcome,
  ProFeatures,
  DeepResearchAndSearch,
  Newsletters,
  Titv,
  Settings,
  DownloadApp,
] as const;

export const ANNUAL_STEPS: StepTuple = [
  Welcome,
  Newsletters,
  Titv,
  DeepResearchAndSearch,
  Settings,
  ProFeatures,
  DownloadApp,
] as const;

// Article page: add ArticleShare before DownloadApp
export const PRO_STEPS_ARTICLE: StepTuple = [
  Welcome,
  ProFeatures,
  DeepResearchAndSearch,
  Newsletters,
  Titv,
  Settings,
  ArticleShare,
  DownloadApp,
] as const;

export const ANNUAL_STEPS_ARTICLE: StepTuple = [
  Welcome,
  Newsletters,
  Titv,
  DeepResearchAndSearch,
  Settings,
  ProFeatures,
  ArticleShare,
  DownloadApp,
] as const;

export const PRO_MOBILE_STEPS: StepTuple = [
  MobileWelcome,
  MobileProFeatures,
  MobileDeepResearchAndSearch,
  MobileNewsletters,
  MobileTitv,
  MobileSettings,
  MobileDownloadApp,
] as const;

export const ANNUAL_MOBILE_STEPS: StepTuple = [
  MobileWelcome,
  MobileNewsletters,
  MobileTitv,
  MobileDeepResearchAndSearch,
  MobileSettings,
  MobileProFeatures,
  MobileDownloadApp,
] as const;

export const PRO_MOBILE_STEPS_ARTICLE: StepTuple = [
  MobileWelcome,
  MobileProFeatures,
  MobileDeepResearchAndSearch,
  MobileNewsletters,
  MobileTitv,
  MobileSettings,
  MobileArticleShare,
  MobileDownloadApp,
] as const;

export const ANNUAL_MOBILE_STEPS_ARTICLE: StepTuple = [
  MobileWelcome,
  MobileNewsletters,
  MobileTitv,
  MobileDeepResearchAndSearch,
  MobileSettings,
  MobileProFeatures,
  MobileArticleShare,
  MobileDownloadApp,
] as const;

export const STEP_COMPONENT_NAMES = new Map<StepComponent, string>([
  [Welcome, ONBOARDING_STEP_IDS.Welcome],
  [MobileWelcome, ONBOARDING_STEP_IDS.Welcome],
  [ProFeatures, ONBOARDING_STEP_IDS.ProFeatures],
  [MobileProFeatures, ONBOARDING_STEP_IDS.ProFeatures],
  [DeepResearchAndSearch, ONBOARDING_STEP_IDS.DeepResearchAndSearch],
  [MobileDeepResearchAndSearch, ONBOARDING_STEP_IDS.DeepResearchAndSearch],
  [Newsletters, ONBOARDING_STEP_IDS.Newsletters],
  [MobileNewsletters, ONBOARDING_STEP_IDS.Newsletters],
  [Titv, ONBOARDING_STEP_IDS.Titv],
  [MobileTitv, ONBOARDING_STEP_IDS.Titv],
  [Settings, ONBOARDING_STEP_IDS.Settings],
  [MobileSettings, ONBOARDING_STEP_IDS.Settings],
  [ArticleShare, ONBOARDING_STEP_IDS.ArticleShare],
  [MobileArticleShare, ONBOARDING_STEP_IDS.ArticleShare],
  [DownloadApp, ONBOARDING_STEP_IDS.DownloadApp],
  [MobileDownloadApp, ONBOARDING_STEP_IDS.DownloadApp],
]);
